import {
  ROUTE_WASABI_HOME,
  ROUTE_WASABI_COURSE_LIST,
  ROUTE_WASABI_COURSE_INFO,
  ROUTE_WASABI_INSTITUTION_LIST,
  ROUTE_WASABI_INSTITUTION_INFO,
  ROUTE_WASABI_USER_LIST,
  ROUTE_WASABI_USER_INFO,
  ROUTE_WASABI_EMAIL_TEMPLATES,
  ROUTE_WASABI_PAYMENTS,
  ROUTE_WASABI_SUBSCRIPTIONS,
  ROUTE_WASABI_PORTFOLIO_INSTITUTIONS,
  ROUTE_WASABI_SAAS,
} from '../../../ReduxStorage/routeActions';

import {
  COURSE_NOT_LISTED,
  COURSE_UNDER_REVIEW,
  COURSE_REQ_IMPROVEMENT,
  COURSE_LISTED,
} from '../StarterPage/QualityCriteriaConstants';

export const WasabiPages = [
  ROUTE_WASABI_HOME,
  ROUTE_WASABI_COURSE_LIST,
  ROUTE_WASABI_COURSE_INFO,
  ROUTE_WASABI_INSTITUTION_LIST,
  ROUTE_WASABI_INSTITUTION_INFO,
  ROUTE_WASABI_USER_LIST,
  ROUTE_WASABI_USER_INFO,
  ROUTE_WASABI_EMAIL_TEMPLATES,
  ROUTE_WASABI_PAYMENTS,
  ROUTE_WASABI_SUBSCRIPTIONS,
  ROUTE_WASABI_PORTFOLIO_INSTITUTIONS,
  ROUTE_WASABI_SAAS,
];

export const COURSE_LIST_PAGINATION_SIZE = 25;

export const MENU_ITEMS_CUSTOMER_SUPPORT = [
  {
    label: 'SaaS Subscriptions',
    isActive: (props) => {
      return props.type === ROUTE_WASABI_SAAS;
    },
    action: {
      type: ROUTE_WASABI_SAAS,
      params: {},
    },
  },
  {
    label: 'Courses',
    isActive: (props) => {
      return (
        props.type === ROUTE_WASABI_COURSE_LIST ||
        props.type === ROUTE_WASABI_COURSE_INFO
      );
    },
    action: {
      type: ROUTE_WASABI_COURSE_LIST,
      params: {},
    },
  },
  {
    label: 'Institutions',
    isActive: (props) => {
      return (
        props.type === ROUTE_WASABI_INSTITUTION_LIST ||
        props.type === ROUTE_WASABI_INSTITUTION_INFO
      );
    },
    action: {
      type: ROUTE_WASABI_INSTITUTION_LIST,
      params: {},
    },
  },
  {
    label: 'Users',
    isActive: (props) => {
      return (
        props.type === ROUTE_WASABI_USER_LIST ||
        props.type === ROUTE_WASABI_USER_INFO
      );
    },
    action: {
      type: ROUTE_WASABI_USER_LIST,
      params: {},
    },
  },
  {
    label: 'Porfolio Tools',
    isActive: (props) => {
      return props.type === ROUTE_WASABI_PORTFOLIO_INSTITUTIONS;
    },
    action: {
      type: ROUTE_WASABI_PORTFOLIO_INSTITUTIONS,
    },
  },
];

export const MENU_ITEMS_PLATFORM_TRUTH = [
  {
    label: 'Email Templates',
    isActive: (props) => {
      return props.type === ROUTE_WASABI_EMAIL_TEMPLATES;
    },
    action: {
      type: ROUTE_WASABI_EMAIL_TEMPLATES,
      params: {},
    },
  },
  {
    label: 'Subscriptions',
    isActive: (props) => {
      return props.type === ROUTE_WASABI_SUBSCRIPTIONS;
    },
    isSuperUserOnly: true,
    action: {
      type: ROUTE_WASABI_SUBSCRIPTIONS,
      params: {},
    },
  },
  {
    label: 'Storybook',
    isActive: () => false,
    isSuperUserOnly: true,
    href: 'http://storybook.openlearning.com',
  },
];

export const COURSE_LIST_PAGE_REVIEW_STATUS = [
  {
    label: 'Any',
    value: '',
  },
  {
    label: 'Not Listed',
    value: COURSE_NOT_LISTED,
  },
  {
    label: 'Waiting For or Under Review',
    value: COURSE_UNDER_REVIEW,
  },
  {
    label: 'Requires improvement',
    value: COURSE_REQ_IMPROVEMENT,
  },
  {
    label: 'Courses Listed',
    value: COURSE_LISTED,
  },
];

export const COURSE_LIST_PAGE_SORTBY = [
  { value: '-created', label: 'Date created (descending)' },
  { value: 'created', label: 'Date created' },
  { value: 'name', label: 'Name' },
  { value: '-name', label: 'Name (descending)' },
  {
    value: '-reviewdate',
    label: 'Review Request Date (descending)',
  },
  { value: 'reviewdate', label: 'Review Request Date' },
  // twig: Not possible because Mongo is awful
  // { value: 'creator', label: 'Course Creator' },
];

export const COURSE_LIST_PAGE_FILTER_BOOLEAN_OPTIONS = [
  { value: '', label: 'Any' },
  { value: 'true', label: 'True' },
  { value: 'false', label: 'False' },
];
